<template>
    <div>
        <span v-bind:title="content.tooltip" v-on:click.stop="aboutPage = true" class="about">
            <font-awesome-icon icon="info"/>
        </span>
      <transition name="fade">
        <div v-if="aboutPage" v-on:click.self.stop="aboutPage = false" class="aboutPage">
          <div class="aboutPage-content">
            <span v-on:click="aboutPage = false" style="float: right"> <font-awesome-icon icon="times"/></span>
            <h1>{{name}}</h1>
            <div v-html="content.content"></div>
           Source: <a v-on:click.self.stop target="_blank" v-bind:href="content.sourceurl"> {{content.sourcename}}</a>
          </div>
        </div>
      </transition>

    </div>

</template>

<script>
    export default {
        name: "AboutPage",
      props: ['name', 'content', 'tooltip'],
        data: function () {
            return {
                aboutPage: false,
            }
        },
    }
</script>

<style scoped>

    .about {
        float: right;
        padding: 5px;
    }

    .aboutPage {
        position: fixed;
        background: rgba(46, 60, 67, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 200;
        opacity: 1;
        overflow: hidden;
    }

    .aboutPage-content {
        background: white;
        max-width: 80%;
        border: #fffcfc solid 2px;
        border-radius: 10px;
        padding: 10px 30px;
        max-height: 80%;
        overflow: auto;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
    }

    .fade-enter, .fade-leave-to
    {
        opacity: 0;
    }

    .fade-enter-active .aboutPage-content, .fade-leave-active .aboutPage-content {
        transition: transform 1s;
    }

    .fade-enter .aboutPage-content, .fade-leave-to .aboutPage-content {
        transform: translate(-50vw, -50vh) scale(0);
    }

    .fade-enter-to .aboutPage-content, .fade-leave-to .aboutPage-content {
        overflow: hidden;
    }

</style>
